import { privateApi } from '../utils/axios';

// Get all guests for an event
export const getEventGuests = async (eventId) => {
  const response = await privateApi.get(`/events/${eventId}/guests`);
  return response.data;
};

// Get all guests for a user
export const getUserGuests = async () => {
  const response = await privateApi.get('/guests');
  return response.data;
};

export const exportContacts = async () => {
  const response = await privateApi.get('/guests/export', { responseType: 'blob' });
  if (!response.headers['content-type']?.toLowerCase().startsWith('text/csv')) {
    throw new Error('The server is still returning the old Excel format. Restart the updated backend and try again.');
  }
  return response.data;
};

export const importContacts = async (contacts) => {
  const response = await privateApi.post('/guests/import', { contacts });
  return response.data;
};

// Get all guests for multiple events
export const getEventsGuests = async (eventIds) => {
  const response = await privateApi.get(`/events/multi-view/guests?eventIds=${eventIds.join(',')}`);
  return response.data;
}

// Create a new guest
export const createGuest = async (eventId, guestData) => {
  const response = await privateApi.post(`/events/${eventId}/guests`, guestData);
  return response.data;
};

// Update a guest
export const updateGuest = async (guestId, guestEventId, guestData) => {
  const response = await privateApi.put(`/guests/${guestId}`, { ...guestData, guestEventId: guestEventId });
  return response.data;
};

// Delete a guest (either completely or just from the event)
export const deleteGuest = async (guestId, guest_event_id, action) => {
  try {
    let url;
    if (action === 'delete_completely') {
      // If deleting completely, use the guest ID only
      url = `/guests/${guestId}`;
    } else if (action === 'delete_from_event') {
      // If deleting from event, include guest_event_id
      url = `/guests/${guestId}/event/${guest_event_id}`;
    }
    const response = await privateApi.delete(url);
    return response.data;
  } catch (error) {
    throw new Error(`Failed to delete guest: ${error.message}`);
  }
};
